import React from 'react';

const TermsConditions = () => {
    return (
        <div className="bg-gray-100 min-h-screen flex items-center justify-center">
            <div className="max-w-3xl bg-white rounded-lg shadow-lg p-8">
                <h1 className="text-3xl font-semibold mb-6 text-center">Terms and Conditions</h1>
                <div className="text-gray-800">
                    <p className="mb-4">
                        By accessing and using this website, you agree to the following terms and conditions.
                    </p>
                    <p className="mb-4">
                        The content of this website is for general information purposes only and is subject to change without notice.
                        We do not provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness, or suitability of the information and materials found or offered on this website for any particular purpose.
                    </p>
                    <p className="mb-4">
                        Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable.
                        It shall be your own responsibility to ensure that any products, services, or information available through this website meet your specific requirements.
                    </p>
                    <p className="mb-4">
                        This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance, and graphics.
                        Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
                    </p>
                    <p className="mb-4">
                        Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.
                        From time to time, this website may also include links to other websites. These links are provided for your convenience to provide further information.
                        They do not signify that we endorse the website(s). We have no responsibility for the content of the linked website(s).
                    </p>
                    <p>
                        Your use of this website and any dispute arising out of such use of the website is subject to the laws of [India/Tamil Nadu].
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TermsConditions;
